import { useEffect, useCallback } from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { ChevronLeft, ChevronRight } from "lucide-react"

type Props = {
  prevId: string | null
  nextId: string | null
  navKey: string
  baseUrl: string
}

export function ProjectNavigation({ prevId, nextId, navKey, baseUrl }: Props) {
  const goTo = useCallback(
    (id: string) => {
      router.visit(`${baseUrl}/${id}?nav=${navKey}`, { preserveState: false })
    },
    [navKey, baseUrl],
  )

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || (e.target as HTMLElement)?.isContentEditable) return
      if (e.key === "ArrowLeft" && prevId) goTo(prevId)
      if (e.key === "ArrowRight" && nextId) goTo(nextId)
    }
    document.addEventListener("keydown", handler)
    return () => document.removeEventListener("keydown", handler)
  }, [prevId, nextId, goTo])

  return (
    <div className="flex items-center gap-0.5">
      <Button
        variant="ghost"
        size="icon"
        className="size-7"
        disabled={!prevId}
        onClick={() => prevId && goTo(prevId)}
        title="Projet précédent"
      >
        <ChevronLeft className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="size-7"
        disabled={!nextId}
        onClick={() => nextId && goTo(nextId)}
        title="Projet suivant"
      >
        <ChevronRight className="size-4" />
      </Button>
    </div>
  )
}
